import { Box, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';
import { useDossieService } from '../../../../../../use-cases/dossie';

export const DossieError = ({ message }: { message: string }) => {
  const navigate = useNavigate();
  const { fecharOrigemConsulta } = useDossieService();

  return (
    <Box
      sx={{
        width: '100%',
        flexGrow: 1,
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'radial-gradient(circle at 50% -20%, #ffffff 0%, #f0ebf5 100%)',
        padding: 2,
      }}
    >
      <Box
        sx={{
          backgroundColor: '#ffffff',
          borderRadius: '24px',
          boxShadow: '0 24px 48px -12px rgba(114, 57, 137, 0.25), 0 4px 24px rgba(0,0,0,0.04)',
          border: '1px solid rgba(255,255,255,0.8)',
          padding: { xs: 4, md: 6 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 400,
          width: '100%',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '6px',
            backgroundColor: '#d32f2f',
          },
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 64, color: '#d32f2f', mb: 2 }} />
        <Typography variant="h5" sx={{ fontWeight: 800, color: '#1e293b', mb: 1.5, letterSpacing: '-0.5px', textAlign: 'center' }}>
          Ops! Falha na Busca
        </Typography>
        <Typography variant="body1" sx={{ color: '#666', textAlign: 'center', lineHeight: 1.6, mb: 4 }}>
          {message}
        </Typography>
        <Button
          onClick={() => {
            fecharOrigemConsulta();
            navigate('/private/dossie/search');
          }}
          sx={{
            background: 'linear-gradient(135deg, #723989 0%, #9c4dcc 100%)',
            color: '#fff',
            borderRadius: '12px',
            padding: '10px 24px',
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': { background: 'linear-gradient(135deg, #5c2d6e 0%, #8340ab 100%)' },
          }}
        >
          Voltar para pesquisa
        </Button>
      </Box>
    </Box>
  );
};
